import React, { createContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

import reducer from './Reducer';
import actions from './Actions';

const initialState = {
  enterpriseId: null,
  policyEnabled: null,
  paymentInformation: {},
  paymentMethods: null,
  policy: null,
};

const context = createContext();

export function ContextProvider({ enterpriseId, policyEnabled, children }) {
  initialState.enterpriseId = enterpriseId;
  initialState.policyEnabled = policyEnabled;
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => ({
    state, dispatch, actions,
  }), [state, dispatch, actions]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
}

ContextProvider.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  policyEnabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export const useContext = () => React.useContext(context);
